import { $http } from "@/assets/js/appFunc";

export const actRetrieveFromURL = (context, data) => {
    const req = {
        type: "POST",
        url: "/integration/ssl/retrieve-from-url",
        data,
        headers: { "Content-Type": "application/json" }
    };
    return $http(req, true);
};

export const actSaveCertificate = (context, data) => {
    const req = {
        type: "POST",
        url: "/integration/ssl",
        data
    };
    return $http(req, true);
};

export const actAllCertificates = () => {
    const req = {
        type: "GET",
        url: "/integration/ssl/all"
    };
    return $http(req, true);
};

export const actDeleteCertificate = (context, id) => {
    const req = {
        type: "DELETE",
        url: `/integration/ssl/${id}`
    };
    return $http(req, true);
};
